// extracted by mini-css-extract-plugin
export default {"base":"s0yys"};